import { template } from "@ember/template-compiler";
import RouteTemplate from 'ember-route-template';
import WrModalContent from 'ember-wiser/components/wr/modal/content';
import WrDivider from 'ember-wiser/components/wr/divider';
import AuthenticationLogin from 'core/components/authentication/login';
import OpenIdConnectButton from 'core/components/authentication/open-id-connect-button';
import Component from '@glimmer/component';
import { service } from '@ember/service';
import type AphpConnectMedic from 'core/services/aphp-connect-medic';
import type ProSanteConnect from 'core/services/pro-sante-connect';
let MedicLoginRouteTemplate = class MedicLoginRouteTemplate extends Component {
    @service
    proSanteConnect: ProSanteConnect;
    @service
    aphpConnectMedic: AphpConnectMedic;
    get atLeastOneOpenIdConnectServiceEnabled() {
        return this.proSanteConnect.isEnabled || this.aphpConnectMedic.isEnabled;
    }
    static{
        template(`
    <WrModalContent @targetModal='login-modal' @title='Connexion soignant'>
      <div class='flex flex-col items-center gap-6'>
        <h2 class='text-h2 text-purple text-center font-sans'>
          Se connecter
        </h2>

        <AuthenticationLogin @userType='medic' />

        {{#if this.atLeastOneOpenIdConnectServiceEnabled}}
          <WrDivider>ou</WrDivider>
        {{/if}}

        <OpenIdConnectButton
          @openIdConnectService={{this.proSanteConnect}}
          class='w-[220px]'
        />

        <OpenIdConnectButton
          @openIdConnectService={{this.aphpConnectMedic}}
          class='w-[220px]'
        />
      </div>
    </WrModalContent>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
};
export default RouteTemplate(MedicLoginRouteTemplate);
